import { useIntl } from 'react-intl';
import { Switch, type SwitchProps, Icon, Tooltip } from '@ets/design-system';

export type ActiveDetailsProps = {
  toggle: SwitchProps['onChange'];
  active: boolean;
  tooltipContent: string; //TODO:TS Set type to TranslationId when translation Ids are all inline
  testId: string;
};

const ActiveDetails = ({ toggle, active, tooltipContent, testId }: ActiveDetailsProps) => {
  const intl = useIntl();
  return (
    <>
      <div style={{ margin: '0 1rem' }}>
        <Switch
          value={active}
          onChange={toggle}
          size="xs"
          labelPlacement="right"
          testId={testId}
          label={intl.formatMessage({
            id: 'global.active',
          })}
        />
      </div>
      <Tooltip
        content={intl.formatMessage({
          id: tooltipContent,
        })}
        testId={`${testId}-information`}
      >
        <div style={{ display: 'flex', flex: '1' }}>
          <Icon icon="circle-info" size="2" testId="info" color="primary" />
        </div>
      </Tooltip>
    </>
  );
};

export default ActiveDetails;
